module.exports = __webpack_public_path__ + "img/7.b47ca405.jpg";